export var DEFAULT_DECLINE_MESSAGE = {
  "default": {
    description: 'Não optar pela contratação do serviço'
  }
};